import React from 'react';
import { HomePage, LoginPage, FeaturesPage } from '@/pages';
import { usePath } from './usePath';

export function AppRouter() {
  const path = usePath();

  if (path === '/login' || path === '/auth') {
    return <LoginPage />;
  }

  if (path === '/features') {
    return <FeaturesPage />;
  }

  return <HomePage />;
}
